export const msUntilNext6AM = () => {
  const now = new Date()
  const next6 = new Date(now)

  next6.setHours(6, 0, 0, 0)

  if (now >= next6) {
    next6.setDate(next6.getDate() + 1)
  }

  return next6.getTime() - now.getTime()
}
